__turbopack_context__.v({
  "atcErrorNotification": "ProductDetailTemplate-module-scss-module__SgFaTW__atcErrorNotification",
  "detailsColumn": "ProductDetailTemplate-module-scss-module__SgFaTW__detailsColumn",
  "featureGrid": "ProductDetailTemplate-module-scss-module__SgFaTW__featureGrid",
  "galleryColumn": "ProductDetailTemplate-module-scss-module__SgFaTW__galleryColumn",
  "heroSection": "ProductDetailTemplate-module-scss-module__SgFaTW__heroSection",
  "productDetailsSticky": "ProductDetailTemplate-module-scss-module__SgFaTW__productDetailsSticky",
  "productTagRow": "ProductDetailTemplate-module-scss-module__SgFaTW__productTagRow",
});
